// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2165":"0becbacc772e6bc9","7938":"cc65a5827dea5692","8144":"36c5798c98d57356","8259":"494a7ed3cb581f99","8552":"8487ce50197aa198"}[chunkId] + ".js";
};